"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: logoRef,
    isVisible: logoVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[hsl(220,20%,25%)]">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1454827/img/hero_abstract_gradient.png)"
    }} />

      {}
      <div className="absolute inset-0 bg-black/30" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center">
        {}
        <div ref={logoRef} className={`flex justify-center mb-8 transition-all duration-[var(--duration-slow)] ${logoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center p-4 bg-background/10 backdrop-blur-sm border border-border-strong/30 rounded-md">
            <img src="https://picked-drum.10web.cloud/wp-content/uploads/2025/11/HHC-1.png" alt="Haven Holdings Capital" className="h-48 md:h-64 w-auto object-contain" />
          </div>
        </div>

        {}
        

        {}
        <p ref={subheadlineRef} className={`font-sans text-lg md:text-xl lg:text-2xl text-foreground-dark/90 mb-12 max-w-3xl mx-auto leading-relaxed transition-all duration-[var(--duration-slow)] delay-100 ${subheadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>Purpose-built properties for tenants in highly regulated industries.&nbsp;</p>

        {}
        <div ref={ctaRef} className={`transition-all duration-[var(--duration-slow)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="/InvestmentStrategyPage">
            <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-105 hover:shadow-medium active:scale-100 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-6 text-base md:text-lg font-semibold rounded-md">
              Learn More
              <ArrowRight className="ml-2 size-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}